import { render } from "./Weight.vue?vue&type=template&id=08f2934e&scoped=true"
import script from "./Weight.vue?vue&type=script&lang=js"
export * from "./Weight.vue?vue&type=script&lang=js"

import "./Weight.vue?vue&type=style&index=0&id=08f2934e&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f2934e"]])

export default __exports__